import styled from '@emotion/styled';

export const EventDetailsOptions = styled('div', { label: 'EventDetailsOptions' })`
    bottom: 0;
    margin: auto 0;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
`;

export const EventDetailsOptionElement = styled('div', { label: 'EventDetailsOptionElement' })`
    margin: 0 0 0 10px !important;
`;

export const SelectElement = styled('select', { label: 'SelectElement' })`
    padding: 0 32px 0 16px !important;
`;
